<template>
  <e-alert variant="error">
    <div class="paragraph-m_h font-600">На указанном периоде есть ограничение, созданное другим пользователем</div>
    <div class="paragraph-s_h text-secondary mt-1">
      Вернитесь к просмотру шахматки, чтобы ознакомиться с&nbsp;новыми ограничениями, при&nbsp;необходимости
      отредактируйте&nbsp;их.
    </div>
  </e-alert>
</template>

<script setup lang="ts">
import { EAlert } from '@/core/components/ui';
</script>
